module.exports = __webpack_public_path__ + "img/Screen_6.36e766e4.png";